import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import NopeZone from 'InpageEditorUI/components/NopeZone';
import { getNodePositionsByStaticModuleId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
// @ts-expect-error not yet migrated
import { generateTilesOutsideOf } from 'layout-dnd-utils/geometry/tiling';
// @ts-expect-error not yet migrated
import { getElementBounds } from 'layout-dnd-utils/dom/bounds';
import { createSelector } from 'reselect';
import { getIsAnythingDragging } from '../redux/selectors/layoutSectionDndSelectors';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const selectPostBodyNodePosition = createSelector(getNodePositionsByStaticModuleId, nodePositionsByStaticModuleId => {
  return nodePositionsByStaticModuleId && nodePositionsByStaticModuleId['post_body'];
});
const generateNopeZoneTiles = postBodyNodePosition => {
  if (!postBodyNodePosition) {
    return [];
  }
  const documentBounds = getElementBounds(document.documentElement, {
    applyScrollOffset: true
  });
  try {
    return generateTilesOutsideOf(documentBounds, [postBodyNodePosition]);
  } catch (err) {
    console.error('Error generating nope zone tiles: ', err);
    return [];
  }
};
function BlogNopeZone() {
  const postBodyNodePosition = useSelector(selectPostBodyNodePosition);
  const isAnythingDragging = useSelector(getIsAnythingDragging);
  const nopeZoneTiles = useMemo(() => generateNopeZoneTiles(postBodyNodePosition), [postBodyNodePosition]);
  return /*#__PURE__*/_jsx(View, {
    display: isAnythingDragging ? 'block' : 'none',
    children: nopeZoneTiles.map((tile, i) => /*#__PURE__*/_jsx(NopeZone, {
      top: tile.top,
      bottom: tile.bottom,
      right: tile.right,
      left: tile.left
    }, i))
  });
}
export default BlogNopeZone;